import React from 'react'
import LeftSidebar from "../../components/LeftSidebar/LeftSidebar"
import HomeMainbar from "../../components/HomeMianbar/HomeMainbar"
import "../../App.css"

const Questions = () => {
  return (
    <div className='home-container-1'>
      <LeftSidebar/>
      <div className='home-container-2'>
        <HomeMainbar/>
      </div>
    </div>
  )
}

export default Questions
